module.exports = __webpack_public_path__ + "img/cooperate_qy_17@2x.46cae89c.png";